// Desliga o gesto de voltar/avançar do touchpad (macOS/Chrome): a página
// deslizava pros lados a cada swipe horizontal e podia sair do wizard sem querer.
export default function CssBaseline() {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        html: { overscrollBehaviorX: "none" },
        body: { overscrollBehaviorX: "none" },
        // Listas com rolagem horizontal (filtros de Ativos, tabelas do Histórico)
        // encadeavam o gesto para o navegador ao chegar no fim: no iPhone isso
        // vira o swipe de voltar do Safari e a tela "desliza" para o lado.
        "*": { overscrollBehaviorX: "contain" },
      },
    },
  };
}
